import React from 'react';

import {
  Flex,
  Link,
  Online,
  FlexCol,
  Padding,
  LinkText,
  AvatarText,
  UserContain,
  IconContain,
  PanelContain,
  LinksContain
} from './AvatarStyled';

import Text from 'components/Text';
import Icons from 'components/Icons';

export const UserAvatar = ({
  open,
  user,
  onLogoutClick,
  onAvatarClick,
  onPanelClick,
  onAccountClick,
  onContactClick,
  onConnectionsClick
}) => (
  <Flex>
    <FlexCol />
    <IconContain onClick={onAvatarClick}>
      <AvatarText>{user.userName[0]}</AvatarText>
      <div onClick={onPanelClick} style={{ display: !open ? 'none' : 'block' }}>
        <PanelContain>
          <Padding>
            <UserContain>
              <Flex>
                <Online />
                <Text.Title>{user.userName}</Text.Title>
              </Flex>
              <Text.SubTitle>{user.emailAddress}</Text.SubTitle>
            </UserContain>

            <LinksContain>
              <Link onClick={onAccountClick}>
                <Icons.Account />
                <LinkText>Account</LinkText>
              </Link>

              <Link onClick={onContactClick}>
                <Icons.Message color='#7093a74d' />
                <LinkText>Contact Us</LinkText>
              </Link>

              <Link onClick={onConnectionsClick}>
                <Icons.Message color='#7093a74d' />
                <LinkText>Connections</LinkText>
              </Link>

              <Link onClick={onLogoutClick}>
                <Icons.Logout />
                <LinkText>Logout</LinkText>
              </Link>
            </LinksContain>
          </Padding>
        </PanelContain>
      </div>
    </IconContain>
  </Flex>
);

export default UserAvatar;
